import axios from 'axios';
import * as endpoints from './const';

import querystring from 'querystring';

// const getApiUrl = ({endPoint, id, startDate, endDate, countryCode, companyCode}) => {
//   let url = endPoint + `?id=${id}`;
//   if (countryCode) url += `&countryCode=${countryCode}`;
//   if (companyCode) url += `&companyCode=${companyCode}`;
//   if (startDate) url += `&startDate=${startDate}`;
//   if (endDate) url += `&endDate=${endDate}`;
//   return url;
// };

class DriverAllocationApi {
  static fetchDriverAllocations(fetchParams) {
    if (fetchParams && fetchParams.lookupType === 'Driver') {
      return axios
        .get(`${endpoints.DRIVER_SEARCH}`, {
          params: fetchParams
        })
        .then(response => response.data)
        .then(data => {
          const Details = data.data.Details.map(x => ({
            CompanyCode: x.ClientCode,
            CompanyName: x.ClientName,
            RegistrationNumber: x.RegistrationNumber,
            DriverFirstName: x.DriverFirstName,
            DriverSurname: x.DriverSurname,
            DriverId: x.DriverId,
            DriverEmail: x.RegistrationNumber,
            ModelName: x.ModelName,
            MakeName: x.MakeName,
            LeaseId: x.LeaseId,
            CountryCode: x.CountryCode
          }));
          data.data.Details = Details;
          return data;
        })
        .catch(error => {
          throw error;
        });
    }
    return axios
      .get(`${endpoints.RELOCATION_VEHICLES}`, {
        params: fetchParams
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  /** API TO FETCH DRIVER ALLOCATION DETAILS * */
  static getDriverAllocationDetails(fetchParams) {
    return axios
      .get(endpoints.REALLOCATION_DRIVER_ALLOCATION_DETAILS, {
        params: fetchParams
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  /** API TO FETCH DRIVER DETAILS * */
  static getDriverDetails(fetchParams, driverId) {
    const endpointUrl = `${endpoints.REALLOCATION_DRIVER_DETAILS}/${driverId}`;
    return axios
      .get(endpointUrl, {
        params: fetchParams
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static getDrivers(fetchParams) {
    return axios
      .get(endpoints.REALLOCATION_DRIVER_DETAILS, {
        params: fetchParams
      })
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static allocateExistingDriver(country, data) {
    return axios
      .post(
        `${endpoints.REALLOCATE_EXISTING_DRIVER}?countryCode=${country}`,
        data
      )
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  }

  static allocateNewDriver(country, data) {
    return axios
      .post(`${endpoints.REALLOCATE_NEW_DRIVER}?countryCode=${country}`, data)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  }
}

export default DriverAllocationApi;



// WEBPACK FOOTER //
// ./src/api/DriverAllocationApi.js